import { Row, Col, Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import CustomSwitch from '../../../../common/Switch'
import styles from './General.module.css'

export const General = ({ settings, onSettingChange, isSaving }) => {
  const { t } = useTranslation()

  return (
    <div>
      <label className={styles.sectionLabel}>{t('GeneralSettings')}</label>
      <Form>
        <Row>
          <Col md="auto">
            <CustomSwitch
              id="emailNotificationsEnabled"
              label={t('EmailNotificationsEnabled')}
              checked={settings?.emailNotificationsEnabled || false}
              onChange={(e) => onSettingChange('emailNotificationsEnabled', e.target.checked)}
              disabled={isSaving}
              labelPosition="left"
            />
          </Col>
          <Col md="auto">
            <CustomSwitch
              id="sharedCalendarVisibleOnProfile"
              label={t('SharedCalendarVisibleOnProfile')}
              checked={settings?.sharedCalendarVisibleOnProfile || false}
              onChange={(e) => onSettingChange('sharedCalendarVisibleOnProfile', e.target.checked)}
              disabled={isSaving}
              labelPosition="left"
            />
          </Col>
          <Col md="auto">
            <CustomSwitch
              id="sharedCalendarShowOnlyHolidays"
              label={t('SharedCalendarShowOnlyHolidays')}
              checked={settings?.sharedCalendarShowOnlyHolidays || false}
              onChange={(e) => onSettingChange('sharedCalendarShowOnlyHolidays', e.target.checked)}
              disabled={isSaving}
              labelPosition="left"
            />
          </Col>
        </Row>
      </Form>
    </div>
  )
}
